import { api } from '../../../lib/api'

export const REQUEST_RESET_PASSWORD_REQUEST = 'REQUEST_RESET_PASSWORD_REQUEST'
export const REQUEST_RESET_PASSWORD_SUCCESS = 'REQUEST_RESET_PASSWORD_SUCCESS'
export const REQUEST_RESET_PASSWORD_FAILED = 'REQUEST_RESET_PASSWORD_FAILED'

export const requestResetPassword = function (email, onComplete) {
  return function (dispatch) {
    dispatch({
      type: REQUEST_RESET_PASSWORD_REQUEST
    })
    api.requestResetPassword(email).then(resetPasswordResponse => {
      dispatch({
        type: REQUEST_RESET_PASSWORD_SUCCESS,
        payload: resetPasswordResponse
      })
      if (onComplete) onComplete()
    }).catch(error => {
      dispatch({
        type: REQUEST_RESET_PASSWORD_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/profile/request-reset-password.js